import { render, staticRenderFns } from "./HealthCreate.vue?vue&type=template&id=1f23330e&scoped=true"
import script from "./HealthCreate.vue?vue&type=script&lang=js"
export * from "./HealthCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f23330e",
  null
  
)

export default component.exports